// Stash an "I want to inquire with this artist" intent before navigating
// from the public artist page into the editor. The editor reads this on
// mount via TattooApp.jsx, skips the dashboard, and shows a toast naming
// the destination shop so the user knows their inquiry context survived
// the navigation hop. Cleared by the editor after it acknowledges, or
// auto-expires after 30 minutes so a stale tab doesn't keep nagging.
//
// Mirrors stashPendingFlash's pattern. Lives in localStorage rather than
// the URL because the user may pass through auth/login between click and
// editor, which strips query params.
export function stashPendingInquiry({ shop }) {
  if (!shop) return false;
  try {
    localStorage.setItem(
      "tt_pending_inquiry",
      JSON.stringify({
        shopId: shop.id,
        shopSlug: shop.slug || null,
        shopName: shop.display_name || shop.name || "this studio",
        ts: Date.now(),
      })
    );
    return true;
  } catch (e) {
    console.warn("[inquiry] failed to stash pending inquiry", e);
    return false;
  }
}

export function readPendingInquiry({ maxAgeMs = 30 * 60 * 1000 } = {}) {
  try {
    const raw = localStorage.getItem("tt_pending_inquiry");
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return null;
    if (parsed.ts && Date.now() - parsed.ts > maxAgeMs) {
      // Stale — drop it.
      localStorage.removeItem("tt_pending_inquiry");
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function clearPendingInquiry() {
  try {
    localStorage.removeItem("tt_pending_inquiry");
  } catch {}
}

export function stashPendingFlash({
  url,
  name,
  price,
  size,
  tags,
  sizeIn,
  defaultScale,
  ownerShop,
}) {
  try {
    localStorage.setItem(
      "tt_pending_flash",
      JSON.stringify({
        url,
        name,
        price,
        size,
        tags,
        sizeIn,
        defaultScale,
        ts: Date.now(),

        // owner studio
        ownerShopId: ownerShop?.id || null,
        ownerShopName: ownerShop?.display_name || ownerShop?.name || null,
        ownerShopSlug: ownerShop?.slug || null,
      })
    );

    localStorage.setItem(
      "tt_pending_request",
      JSON.stringify({
        kind: "flash",
        ts: Date.now(),
      })
    );

    console.log(
      "[flash] stashed payload",
      JSON.parse(localStorage.getItem("tt_pending_flash") || "null")
    );

    return true;
  } catch (e) {
    console.warn("[flash] failed to stash pending flash", e);
    return false;
  }
}
